// extracted by mini-css-extract-plugin
module.exports = {"container":"_3GgC6AN0V6OLQepQwhrheA","label":"_2u0VClmjT3577BvUA_xgfs","description":"_2N83I8dmXf72hSlO-YpQTM description","icon":"_1hoJ5p_V1XdwzINEl77YHC"};